import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpeechService {
  private synth = window.speechSynthesis;
  speakingEndEvent$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  speakingStartEvent$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  speak(text: string): void {
    if (this.synth.speaking) {
      console.error('SpeechSynthesis is already speaking.');
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);

    utterance.onend = () => {
      this.speakingEndEvent$.next(true);
      console.log('SpeechSynthesisUtterance.onend');
    };

    utterance.onstart = () => {
      this.speakingStartEvent$.next(true);
      console.log('SpeechSynthesisUtterance.onstart');
    };

    utterance.onerror = (event) => {
      this.speakingEndEvent$.next(true);
      console.error('SpeechSynthesisUtterance.onerror', event);
    };

    this.synth.speak(utterance);
  }

  pause()
  {
    if (this.synth == null) {
      return;
    }
    this.synth.pause();
  }

  stop()
  {
    if (this.synth == null) {
      return;
    }
    console.log('speech service cancelling:');
    this.synth.cancel();
  }

  resume()
  {
    if (this.synth == null) {
      return;
    }
    console.log('speech service resume:');
    this.synth.resume();
  }

  isSpeaking()
  {
    if (this.synth == null) {
      return false;
    }
    console.log('speech service is Spreaking:', this.synth.speaking);
    return this.synth.speaking;
  }
}
